import React from "react";
import NOTICE_IMAGE from "images/notice.png";

export default (props) => <img src={NOTICE_IMAGE} {...props} />;
